export const MULTI_FILE_UPLOADER_BATCH_ERROR_CODE = {
  MAX_FILE_COUNT: "MAX_FILE_COUNT",
  TOTAL_FILE_SIZE: "TOTAL_FILE_SIZE",
} as const;

export type MultiFileUploaderBatchErrorCode = keyof typeof MULTI_FILE_UPLOADER_BATCH_ERROR_CODE;

export const FileValidationErrorType = {
  EMPTY_FILE: "empty-file",
  FILE_TYPE: "file-type",
  FILE_SIZE: "file-size",
  IMAGE_DIMENSION: "image-dimension",
  SECURITY: "security",
} as const;

export type FileValidationErrorType =
  (typeof FileValidationErrorType)[keyof typeof FileValidationErrorType];

export const MAX_BATCH_FILE_COUNT = 10;
export const MAX_BATCH_COMBINED_SIZE_BYTES = 1_073_741_824;

export const MULTI_FILE_UPLOADER_DEFAULTS = {
  maxFileCount: MAX_BATCH_FILE_COUNT,
  maxTotalFileSize: MAX_BATCH_COMBINED_SIZE_BYTES,
};
